import { render, staticRenderFns } from "./MenuItemEditor.vue?vue&type=template&id=8da602d8&"
import script from "./MenuItemEditor.vue?vue&type=script&lang=js&"
export * from "./MenuItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports